import axios from 'axios';

const VIA_CEP_URL = 'https://viacep.com.br/ws';

interface IViaCepResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
  erro?: string;
}

export interface IViaCepAdddress {
  cep: string;
  street: string;
  neighborhood: string;
  city: string;
  state: string;
}

/**
 * Return address from provided cep
 *
 * @param {string} cep
 * @return {*}  {Promise<IViaCepResponse>}
 */
export const getAddressFromCep = async (
  cep: string
): Promise<IViaCepAdddress> => {
  try {
    const { data } = await axios.get<IViaCepResponse>(
      `${VIA_CEP_URL}/${cep}/json`
    );

    if (data.erro) {
      throw new Error();
    }

    return {
      cep: cep,
      city: data.localidade,
      neighborhood: data.bairro,
      state: data.uf,
      street: data.logradouro,
    };
  } catch (reason) {
    throw new Error('Não foi possível buscar o endereço pelo CEP.');
  }
};

const ViaCepService = { getAddressFromCep };

export default ViaCepService;

